export default __webpack_public_path__ + "static/media/MQ.1af58b3b.ico";